import { render, staticRenderFns } from "./header.vue?vue&type=template&id=60db4af4&scoped=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"
import style0 from "./header.vue?vue&type=style&index=0&id=60db4af4&prod&lang=scss&scoped=true"
import style1 from "./header.vue?vue&type=style&index=1&id=60db4af4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60db4af4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlatformSelection: require('/app/components/PlatformSelection.vue').default})
